import React, { useState, useEffect } from 'react';

export default function PWAInstallBanner() {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // Ne montrer qu'une fois (si l'utilisateur a déjà dismissé)
    const dismissed = localStorage.getItem('pwa-install-dismissed');
    if (dismissed) return;

    const handler = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      setVisible(true);
    };

    window.addEventListener('beforeinstallprompt', handler);
    return () => window.removeEventListener('beforeinstallprompt', handler);
  }, []);

  const handleInstall = async () => {
    if (!deferredPrompt) return;
    deferredPrompt.prompt();
    const { outcome } = await deferredPrompt.userChoice;
    if (outcome === 'accepted') {
      setVisible(false);
    }
    setDeferredPrompt(null);
  };

  const handleDismiss = () => {
    setVisible(false);
    localStorage.setItem('pwa-install-dismissed', '1');
  };

  if (!visible) return null;

  return (
    <div style={{
      position: 'fixed',
      bottom: 0,
      left: 0,
      right: 0,
      zIndex: 9999,
      background: '#fff',
      borderTop: '1px solid #e2e8f0',
      boxShadow: '0 -4px 20px rgba(0,0,0,0.12)',
      padding: '16px 20px',
      display: 'flex',
      alignItems: 'center',
      gap: '12px',
    }}>
      <img src="/logo-eecf.png" alt="EECF" style={{ width: 44, height: 44, borderRadius: 10, flexShrink: 0 }} />
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{ fontWeight: 700, fontSize: 15, color: '#1a202c' }}>Installer l'app EECF</div>
        <div style={{ fontSize: 13, color: '#718096', marginTop: 2 }}>
          Accédez rapidement depuis votre écran d'accueil
        </div>
      </div>
      <button
        onClick={handleInstall}
        style={{
          background: '#1F7040',
          color: '#fff',
          border: 'none',
          borderRadius: 8,
          padding: '9px 18px',
          fontWeight: 700,
          fontSize: 14,
          cursor: 'pointer',
          flexShrink: 0,
        }}
      >
        Installer
      </button>
      <button
        onClick={handleDismiss}
        aria-label="Fermer"
        style={{
          background: 'none',
          border: 'none',
          color: '#a0aec0',
          fontSize: 22,
          cursor: 'pointer',
          padding: '0 4px',
          lineHeight: 1,
          flexShrink: 0,
        }}
      >
        ×
      </button>
    </div>
  );
}
